import {CredentialsCache} from "../common/auth/services/service.credentials";
import {LOG_SERVICES_PROVIDERS} from "../common/log";
import {ThemeService} from "../common/ui/services/theme.changer";
import {DeployedEnv} from "../common/env/services/env";
import {HTTP_PROVIDERS} from "../common/http/services";
import {NgModule} from "@angular/core";
import {SystemConfigurationModule} from "../common/configuration";
import {ReloadAppProvider} from "./global/services/reload.app.provider";
import {LogoutProvider} from "./global/services/logout.provider";
import {AppSettingsProvider} from "./global/services/app.settings.provider";
import {ThemeProxy} from "../common/ui/services/theme.proxy";

// a module containing providers which are accessible throughout the application -
// including before the login.
// it would have been better if all these providers were declared in their own modules..
@NgModule({})
export class GlobalAppProvidersModule{
	public static forRoot() {
		return {
			ngModule: GlobalAppProvidersModule,
			imports:[
				SystemConfigurationModule.forMainAppRoot(),
			],
			providers: [
				LogoutProvider,
				ReloadAppProvider,
				CredentialsCache,
				DeployedEnv,
				...LOG_SERVICES_PROVIDERS,
				HTTP_PROVIDERS,
				ThemeService,
				ThemeProxy,
				AppSettingsProvider
			]
		};
	}
}
